<template>
  <v-row justify="center">
    
    <v-dialog v-model="show_modal" persistent max-width="700px">
      <v-card>
        <v-form                       
          ref="formFirma" 
          @submit.prevent="rechazarDocumento"
          v-model="validForm" 
          lazy-validation>
          <v-card-title>
            <span class="headline">Rechazar documento</span>
          </v-card-title>
          <v-card-text>
            <v-text-field 
              v-model="motivo_rechazo"  
              :rules="[rules.required]" 
              label="Motivo del rechazo" 
            >
            </v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn color="blue" text @click="cancelarFirma">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              type="submit"
              color="primary" 
              :loading="loading"
              :disabled="!validForm"
              id="button-firma">
              Rechazar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from "axios";
  export default {
    props: ['show_modal', 'paquete_id'],
    data () {
      return {
        loading: false,
        validForm: false,
        motivo_rechazo: null,
        rules: {
          required: value => !!value || 'Campo Requerido.',
          positivo_mayor_cero: value =>  0 < Number(value) || 'Campo debe ser mayor a cero'
        },
      }
    },
    mounted() {
      
    },
    methods: {
      rechazarDocumento(){
        let _thisvf = this;
        if (this.$refs.formFirma.validate()) 
        {
          let r = confirm("¿Seguro de rechazar el documento?");
          if (r == true)  {
            this.loading = true;
            let paqueteData = {"motivo": this.motivo_rechazo,"PaqueteId": this.paquete_id}
            let postUser = axios.post('Rechazo/Crear', paqueteData, { 'headers': this.$store.state.user.headers })
            return postUser.then((callback) => {
              if(callback.status == 201){
                this.motivo_rechazo = "";
                this.$router.back(- 1);
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Documento rechazado' });
                this.$emit('rechazo-to-parent', {'modal': false, 'data': [] });
              } else {
                this.loading = false;
              }
            }).catch((error) => {
              this.loading = false;
              console.log(error.response.data);
            });
          } else {
            this.cancelarFirma();
          }
        }
      },
      cancelarFirma(){
        this.$emit('rechazo-to-parent', {'modal': false, 'data': [] });
      },
    }
  }
</script>